module.exports = __webpack_public_path__ + "img/in-review.3cc8bc55.png";